export default "__VITE_ASSET__DQg1IWM7__"